import _ from 'lodash'
import { SURVEY_MAPPING } from '../actions/types'
import { constants } from '../Constants/constants'

const INITIAL_STATE = {
  ui: {
    surveyMapping: {},
  },
}

const surveyMappingReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SURVEY_MAPPING.SET_SURVEY_MAPPING_DEFAULT:
      return Object.assign({}, INITIAL_STATE)
    case SURVEY_MAPPING.SET_SURVEY_MAPPING:
    case SURVEY_MAPPING.SET_SURVEY_MAPPING_VALUE:
      return Object.assign(
        {},
        {
          ...state,
          ui: {
            ...state.ui,
            surveyMapping: action.surveyMapping,
          },
        }
      )
    default:
      return state
  }
}

export default surveyMappingReducer
